var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewedSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.772 21C23.9763 21 23.2133 21.3161 22.6507 21.8787C22.088 22.4413 21.772 23.2044 21.772 24C21.772 24.7956 22.088 25.5587 22.6507 26.1213C23.2133 26.6839 23.9763 27 24.772 27C25.5676 27 26.3307 26.6839 26.8933 26.1213C27.4559 25.5587 27.772 24.7956 27.772 24C27.772 23.2044 27.4559 22.4413 26.8933 21.8787C26.3307 21.3161 25.5676 21 24.772 21ZM24.772 29C23.4459 29 22.1741 28.4732 21.2364 27.5355C20.2988 26.5979 19.772 25.3261 19.772 24C19.772 22.6739 20.2988 21.4021 21.2364 20.4645C22.1741 19.5268 23.4459 19 24.772 19C26.0981 19 27.3698 19.5268 28.3075 20.4645C29.2452 21.4021 29.772 22.6739 29.772 24C29.772 25.3261 29.2452 26.5979 28.3075 27.5355C27.3698 28.4732 26.0981 29 24.772 29ZM24.772 16.5C19.772 16.5 15.502 19.61 13.772 24C15.502 28.39 19.772 31.5 24.772 31.5C29.772 31.5 34.042 28.39 35.772 24C34.042 19.61 29.772 16.5 24.772 16.5Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewedSupplyReqIcon);
export default __webpack_public_path__ + "static/media/reviewed-supply-req-icon.e5dd8786e01dd5281f79732d233ba9c3.svg";
export { ForwardRef as ReactComponent };